if (!customElements.get('fc-mobile-sticky-cta')) {
  customElements.define(
    'fc-mobile-sticky-cta',
    class FcMobileStickyCta extends HTMLElement {
      constructor() {
        super();
        this.onScroll = this.onScroll.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.productInfo = this.closest('product-info');
        this.originalButton = this.productInfo?.querySelector(`#${this.dataset.submitButtonId}`);
        this.stickyButton = this.querySelector('[data-fc-mobile-sticky-button]');
        this.stickyLabel = this.querySelector('[data-fc-mobile-sticky-label]');
        this.stickyPrice = this.querySelector('[data-fc-mobile-sticky-price]');

        if (!this.originalButton || !this.stickyButton) return;

        if (document.getElementById('PBarNextFrame')) {
          document.documentElement.classList.add('fc-has-shopify-preview-bar');
        }

        this.syncFromOriginalButton();
        this.observeOriginalButton();
        this.onScroll();

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.mediaQuery.addEventListener?.('change', this.onScroll);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.mediaQuery?.removeEventListener?.('change', this.onScroll);
        this.variantChangeUnsubscriber?.();
        this.observer?.disconnect();
      }

      observeOriginalButton() {
        this.observer = new MutationObserver(() => {
          this.syncFromOriginalButton();
          this.onScroll();
        });
        this.observer.observe(this.originalButton, {
          attributes: true,
          attributeFilter: ['aria-disabled', 'class', 'disabled'],
          childList: true,
          subtree: true,
        });
      }

      syncFromOriginalButton() {
        const originalLabel = this.originalButton.querySelector('span')?.textContent?.trim();
        const isDisabled =
          this.originalButton.hasAttribute('disabled') ||
          this.originalButton.getAttribute('aria-disabled') === 'true';

        this.stickyButton.toggleAttribute('disabled', isDisabled);
        this.stickyButton.classList.toggle('loading', this.originalButton.classList.contains('loading'));

        if (originalLabel && this.stickyLabel) {
          this.stickyLabel.textContent = originalLabel;
        }
      }

      onVariantChange(event) {
        if (event?.data?.sectionId !== this.dataset.sectionId || !this.stickyPrice) return;

        const priceNode = event.data.html?.getElementById(this.dataset.priceId);
        const compactPrice =
          priceNode?.querySelector('.price__sale .price-item--sale')?.textContent?.trim() ||
          priceNode?.querySelector('.price__regular .price-item--regular')?.textContent?.trim();

        if (compactPrice) {
          this.stickyPrice.textContent = compactPrice;
        }
      }

      onScroll() {
        if (!this.originalButton || !this.mediaQuery?.matches) {
          this.setVisible(false);
          return;
        }

        const rect = this.originalButton.getBoundingClientRect();
        const isDisabled = this.stickyButton?.hasAttribute('disabled');
        const hasPassedOriginalCta = rect.bottom < 0;

        this.setVisible(hasPassedOriginalCta && !isDisabled);
      }

      setVisible(isVisible) {
        this.classList.toggle('is-visible', isVisible);
        this.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        this.toggleAttribute('inert', !isVisible);
      }
    }
  );
}
